@if (!isMobile) {
    <div class="add-collection-modal">
        <div class="header-container">
            <div class="header-title">{{ 'COLLECTION_REPORT.NEW_COLLECTION' | translate }}</div>
        </div>
        <form [formGroup]="ElForm">
            <div class="content-container">
                <div class="form-container">
                    <div class="form-field">
                        <div class="field-title" rtlDiv>{{ 'TITLES.SITE_NAME' | translate }}</div>
                        <div class="field-input">
                            <mat-form-field class="form-field-container" rtlDiv>
                                <mat-select class="full-height" panelClass="panel-dropdown" rtlDiv formControlName="site" name="site">
                                    @for (site of binSitesToDisplay; track site) {
                                        <mat-option rtlDiv [value]="site.site_id" class="list-item">
                                          <span rtlDiv>{{ site.site_name }}</span>
                                        </mat-option>
                                      }
                                </mat-select>
                              </mat-form-field>
                        </div>
                    </div>
                    <div class="flexRow-frame" rtlDiv>
                        <div class="form-field half-width">
                            <div class="field-title" rtlDiv>{{ 'TICKET_MANAGEMENT.BIN_NAME' | translate }}</div>
                            <div class="field-input">
                                <mat-form-field class="form-field-container" rtlDiv>
                                    <mat-select class="full-height" panelClass="panel-dropdown" rtlDiv formControlName="binName" name="binName">
                                        @for (bin of filteredBins; track bin) {
                                            <mat-option rtlDiv [value]="bin.bin_id" class="list-item">
                                              <span rtlDiv>{{ bin.bin_name }}</span>
                                            </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="form-field half-width">
                            <div class="field-title" rtlDiv>{{ 'TICKET_MANAGEMENT.BIN_ADDRESS' | translate }}</div>
                            <div class="field-input">
                                <mat-form-field class="form-field-container" rtlDiv>
                                    <input type="text" matInput formControlName="binAddress" rtlDiv>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="flexRow-frame" rtlDiv>
                        <div class="form-field half-width">
                            <div class="field-title" rtlDiv>{{ 'LIVE_INFO.LIST_COLLECTION_TIME' | translate }}</div>
                            <div class="field-input">
                                <mat-form-field class="form-field-container" rtlDiv>
                                    <input class="input-field" [ngxTimepicker]="collection_time" [format]="24" matInput formControlName="collection_time" readonly>
                                    <ngx-material-timepicker [theme]="staticTheme" [confirmBtnTmpl]="confirmBtn" [cancelBtnTmpl]="cancelBtn" #collection_time></ngx-material-timepicker>
                                    <ng-template #cancelBtn>
                                      <div class="manage-bins-btn-container" rtlDiv>
                                        <a class="manage-bins-btn" rtlDiv>{{ 'MANAGE_BIN.CANCEL' | translate }}</a>
                                      </div>
                                    </ng-template>
                                    <ng-template #confirmBtn>
                                      <div class="manage-bins-btn-container" rtlDiv>
                                        <a class="manage-bins-btn" rtlDiv>{{ 'SITE_MANAGMENT.OK' | translate }}</a>
                                      </div>
                                    </ng-template>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="form-field half-width">
                            <div class="field-title" rtlDiv>{{ 'LIVE_INFO.LIST_COLLECTION_DATE' | translate }}</div>
                            <div class="field-input">
                                <div class='datepicker-wrapper' rtlDiv>
                                    <div class='selected-dates' (click)='showHideDatePicker()'>
                                        <div class='dates-range datepicker-rtl' rtlDiv>
                                            {{dateLbl}}
                                        </div>
                                    </div>
                                    <div class="datepicker-container" rtlDiv>
                                        <app-datepicker-custom [hidden]='!showDatePicker' (selectDates)='onSelectDates($event)'></app-datepicker-custom>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="flexRow-frame">
                        <div class="form-field half-width">
                            <div class="field-title" rtlDiv>{{ 'COLLECTION_REPORT.PRE_PICKUP' | translate }}</div>
                            <div class="field-input">
                                <div class="pre-pickup-title">
                                    <nouislider [tooltips]="[true]" [connect]="[true, false]" [min]="0" [max]="100" [step]="1" formControlName="prePickup"></nouislider>
                                    <div class="legend-container">
                                      <span class="legend">0%</span>
                                      <span class="legend">100%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-field half-width">
                            <div class="field-title" rtlDiv>{{ 'COLLECTION_REPORT.POST_PICKUP' | translate }}</div>
                            <div class="field-input">
                                <div class="post-pickup-title">
                                    <nouislider [tooltips]="[true]" [connect]="[true, false]" [min]="0" [max]="100" [step]="1" formControlName="postPickup"></nouislider>
                                    <div class="legend-container">
                                      <span class="legend">0%</span>
                                      <span class="legend">100%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="btns-container" rtlDiv>
                    <div class="cancel-btn" (click)="closeModal()">{{ 'TRUCK_MAP.CANCEL' | translate }}</div>
                    <div class="apply-btn" [ngClass]="{'disabled_btn' : !ElForm.valid}" (click)="applyChanges()">{{ 'TICKET_MANAGEMENT.ADD' | translate }}</div>
                </div>
            </div>
        </form>
    </div>
}

@if (isMobile) {}